import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MessageBox } from '@vertesia/ui/core';
import { VertesiaErrorBoundary } from './VertesiaErrorBoundary';
import { useUITranslation } from '../../i18n/index.js';
export function PanelErrorBoundary({ children }) {
    return (_jsx(VertesiaErrorBoundary, { fallback: PanelErrorFallback, children: children }));
}
function PanelErrorFallback({ error }) {
    const { t } = useUITranslation();
    return (_jsxs(MessageBox, { status: "error", title: t('errors.somethingWentWrong'), children: [_jsxs("div", { className: 'mb-4', children: [t('errors.teamNotifiedLine1'), ' ', t('errors.teamNotifiedLine2'), "\u00A0", _jsx("a", { className: 'text-info', href: "mailto:support@vertesiahq.com", children: "support@vertesiahq.com" }), "."] }), error?.message &&
                _jsx("code", { className: 'w-full mt-4 text-sm text-muted break-words', children: error.message })] }));
}
//# sourceMappingURL=PanelErrorBoundary.js.map